import { createHeader, createSubHeader, createBulletPoint } from "./componentHelpers"

export const renderAwardsSection = (awardExperiences) => {
  if (!awardExperiences || awardExperiences.length === 0) {
    return []
  }
  
  return [
    ...createHeader("AWARDS"),
    ...awardExperiences
      .filter((experience) => experience)
      .flatMap((experience) => {

        const title = experience.title || 'TITLE'
        const issuer = experience.issuer || 'ISSUER'
        const associatedOrg = experience.associatedOrg
        const endDate = experience.endDate || 'DATE AWARDED'
        const bulletPoints = experience.bulletPoints || []

        const headerText = `${issuer}${associatedOrg && ", associated with " + associatedOrg}`

        return [
          createSubHeader(title, headerText, "", "", endDate),
          bulletPoints.map(b => createBulletPoint(b)),
        ].flat()
      }),
  ]
}
